import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import DatePicker from 'react-datepicker';

import Header from '../../../controls/header/Header.jsx';
import Image from '../../../controls/image/Image.jsx';
import CostTypeSelector from '../../../controls/costTypeSelector/CostTypeSelector.jsx';
import ProgressBar from '../../../controls/progressBar/ProgressBar.jsx';

import { routes } from 'pluton-core/lib/constants/routes.constant';
import { history } from '../../../../entry/history';

import {
    ICON_SETTING,
    CONTROLS_IMAGES,
    IMAGE_LOGO
} from 'pluton-core/lib/constants/image.constant';
import { DATEPICKER_FORMAT } from 'pluton-core/lib/constants/data.constant';
import {
    getMaxDate,
    isAllowNextPeriod,
    getCostModeLabel
} from 'pluton-core/lib/services/core/cost/cost.helper';

import { composeCostChartComponent } from 'pluton-charts/lib/charts/cost/CostChartComponent';
import {
    VictoryChart,
    VictoryGroup,
    VictoryArea,
    VictoryZoomContainer,
    VictoryLabel,
} from "victory";

import { VictoryAxis } from '../../../charts/victory/cost/VictoryAxis';


const CostChartComponent = composeCostChartComponent({
    VictoryAxis,
    VictoryChart,
    VictoryGroup,
    VictoryArea,
    VictoryZoomContainer,
    VictoryLabel,
});

class CostPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showOther: true,
            availableHeight: 0
        }
    }

    onGoToControlDetails = (control) => {
        history.push(routes.device(control.deviceId));
    };

    handleDatePickerChanged = (e) => {
        this.props.handleDateChange(e);
    };

    handleChartType = (e) => {
        this.props.handleChartType(e.target.value);
    };

    handleGetPrev = (e) => {
        this.props.handleGetPrev();
    };

    handleGetNext = (e) => {
        this.props.handleGetNext();
    };

    handleClickShowOther = () => {
        this.setState((prevState)=> {
            return {
                showOther: !prevState.showOther
            }
        });
    };

    renderHeader = () => {
        return (
            <Header ref="headerRef" headerTitle='Cost'>
                <div className="header__logo header__logo--left">
                    <Image
                        src={IMAGE_LOGO}
                        className="header__icon"
                        imgClassName="icon icon--header"
                    />
                </div>
                <Link className="header__link header__link--right"
                      to={`${routes.settings()}`}>
                    <Image
                        src={ ICON_SETTING }
                        className="header__icon header__icon--right"
                        imgClassName="icon icon--header"
                    />
                </Link>
            </Header>
        );
    };

    renderChartFilter = () => {
        const isAllowNext = isAllowNextPeriod(this.props.date, this.props.costState.type);
        return (
            <div ref="chartFilterRef" className="chart-nav">
                <div className="chart-nav__prev" onClick={this.handleGetPrev}>
                    prev
                </div>
                <div className="chart-nav__select">
                    <CostTypeSelector
                        value={this.props.costState.type}
                        onChange={this.handleChartType}
                    />
                </div>
                {
                    isAllowNext &&
                    <div className="chart-nav__next" onClick={this.handleGetNext}>
                        next
                    </div>
                }
            </div>
        );
    };

    renderChart = () => {
        return (
            <div ref="chartRef" className="chart chart--cost">
                <CostChartComponent data={this.props.costData.chart}/>
            </div>
        );
    };

    renderBodyHeader = () => {
        return (
            <div ref="bodyHeaderRef" className="page__top">
                <div className="datepicker">
                    <DatePicker
                        ref="datepicker"
                        readOnly={true}
                        autoFocus={false}
                        dateFormat={DATEPICKER_FORMAT}
                        selected={moment(this.props.date)}
                        onChange={this.handleDatePickerChanged}
                        className='datepicker__field'
                        maxDate={getMaxDate()}
                    />
                </div>
                <Link className="link link--arrow">
                    All
                </Link>
            </div>
        );
    };

    renderDetails = () => {
        if (!this.props.controlsData.items.length || !this.props.costData.energy.energyItems.length) {
            return null;
        }

        const labelCostMode = getCostModeLabel(this.props.settings);

        const renderItem = (energyItem, index) => {
            const itemInfoIndex = this.props.controlsData.items.findIndex(i => i.deviceId === energyItem.deviceId);
            const item = itemInfoIndex >= 0 ?
                this.props.controlsData.items[itemInfoIndex] : null;

            const { Icon } = item.data.icon;
            const imgView = (
                <Icon fill={'#00527d'}/>
            );

            return (
                <div key={index} className="cost__item" onClick={this.onGoToControlDetails.bind(null, item)}>
                    <div className="cost__icon">
                        {imgView}
                    </div>
                    <div className="cost__title">
                        {item ? item.data.name : energyItem.deviceId}
                    </div>
                    <div className="cost__price">
                        {energyItem.power} {labelCostMode}
                    </div>
                </div>
            );
        };

        const renderOther = (index) => {
            return (
                <div key={index} className="cost__item cost__item--other">
                    <div className="cost__icon" onClick={this.handleClickShowOther}>
                        <CONTROLS_IMAGES.ARROW/>
                    </div>
                    <div className="cost__title">
                        Other
                    </div>
                    <div className="cost__price">
                        {this.props.costData.energy.otherEnergySum} {labelCostMode}
                    </div>
                </div>
            );
        };

        const itemsView = this.props.costData.energy.energyItems.map((energyItem, index) => {
            if (index > 2 || +energyItem.power === 0) {
                if (this.state.showOther) {
                    return index === 3 ? renderOther(index) : null;
                }

                return renderItem(energyItem, index);
            }

            return renderItem(energyItem, index);
        });

        const FOOTER_HEIGHT = 65;
        const availableHeight = window.innerHeight
            - (this.refs.headerRef && this.refs.headerRef.refs.headerRef.clientHeight)
            - (this.refs.chartFilterRef && this.refs.chartFilterRef.clientHeight)
            - (this.refs.bodyHeaderRef && this.refs.bodyHeaderRef.clientHeight)
            - (this.refs.chartRef && this.refs.chartRef.clientWidth) * 3 / 4
            - FOOTER_HEIGHT;

        return (
            <div className="cost" style={{height:`${availableHeight}px`}}>
                {itemsView}
                {this.renderTotal()}
            </div>
        );
    };

    renderTotal = () => {
        const labelCostMode = getCostModeLabel(this.props.settings);

        return (
            <div ref="totalRef" className="total">
                <div className="total-sum">
                    <div className="total-sum__text">
                        Total energy
                    </div>
                    <div className="total-sum__amount">
                        {this.props.costData.energy.energySum.P} {labelCostMode}
                    </div>
                </div>
            </div>
        );

        // While no tariff
        /*
         <div className="total-tariff total-tariff--first">
         <div className="total-tariff__text">Tariff 1</div>
         <div className="total-tariff__amount">20.89 $</div>
         </div>
         <div className="total-tariff total-tariff--second">
         <div className="total-tariff__text">Tariff 1</div>
         <div className="total-tariff__amount">20.89 $</div>
         </div>
         </div>
         );
         */
    };

    renderLoading = () => {
        if (this.props.isLoading) {
            return (
                <ProgressBar/>
            );
        }

        return null;
    };

    render() {
        return (
            <div className="app-container">
                <div className="page">
                    {this.renderHeader()}
                    <div className="page__content">
                        {this.renderLoading()}
                        {this.renderBodyHeader()}
                        {this.renderChartFilter()}
                        {this.renderChart()}
                        {this.renderDetails()}
                    </div>
                </div>
            </div>
        );
    }
}

CostPage.propTypes = {
    costItems: PropTypes.array,
    costData: PropTypes.object,
    date: PropTypes.object,
    handleDateChange: PropTypes.func,
    handleChartType: PropTypes.func,
    handleGetPrev: PropTypes.func,
    handleGetNext: PropTypes.func,
};

export default CostPage;



// WEBPACK FOOTER //
// ./app/components/pages/core/cost/Cost.page.jsx